<div id="intermediary-fields-container">
  <mm-alternating-text-link-control data-testid="intermediary-selection" [parentForm]="parentForm"
    [alternatingTextLinkControlModel]="intermediaryAddRemoveLinkModel" [isLinkEnabled]="!useSloa"
    [selectedValue$]="wireIntermediary$"></mm-alternating-text-link-control>
  <div id="intermediary-inputs-container" data-testid="intermediary-fields">
    <span *ngIf="(showIntermediaryFields$ | async)" id="header"
      [ngClass]="(isISOCompliant || !useSloa)? 'active mb-10' : 'not-active'">{{isISOCompliant || !useSloa ? intermediaryLabel : intermediaryDetalis}}</span>
    <mm-wire-aba [hidden]="!(showIntermediaryFields$ | async)!" *ngIf="((isFedWire$ | async)! && !useSloa) || useSloa" [parentForm]="parentForm"
      [useSloa]="(useSloa$ | async)!" [isFromCreateTransaction]='isFromCreateTransaction'
      [palAccountInContext]="palAccountInContext"
      [isFromIntermediaryInterim]=true [useTemplate]="(useTemplate$ | async)!" [wireInfo$]="wireInfo$"
      [wireAbaCode$]="wireAbaCode$" [wireDetailsError$]="wireDetailsError$" [wireDetailsWarning$]="wireDetailsWarning$"
      [ngClass] ="(useSloa$ | async)! ? '' : 'medium-bottom-spacer'"></mm-wire-aba>
    <div *ngIf="showIntermediaryFields$ | async">
      <div class="row" *ngIf="!isISOCompliant && useSloa">
        <!-- Intermediary account number -->
        <mm-text-input-control class="input-box" [parentForm]="parentForm" [inputControlModel]="accountNumberModel"
          [errorMessage]="accountNumberError" (blur)="onBlurFieldsTrimWhiteSpace('accountNumber')">
        </mm-text-input-control>
        <!-- Intermediary phone (optional) -->
        <div >
          <mm-text-input-control class="input-box" [parentForm]="parentForm" [inputControlModel]="phoneModel"
            [errorMessage]="phoneError" (input)="onPhoneInput()" (blur)="onBlurFieldsTrimWhiteSpace('phone')">
          </mm-text-input-control>
        </div>
      </div>
      <div *ngIf="(useSloa && !isISOCompliant)">
        <span id="intermediary-name-address-header">{{intermediaryNameAddressSubHeader}}</span>
        <div>
          <div class="row">
            <!-- Intermediary name -->
            <mm-text-input-control class="input-box" [parentForm]="parentForm" [inputControlModel]="nameModel"
            (blur)="onBlurFieldsTrimWhiteSpace('name')">
            </mm-text-input-control>
            <!-- Intermediary name continued (optional) -->
            <mm-text-input-control class="input-box" [parentForm]="parentForm" [inputControlModel]="nameContModel"
            (blur)="onBlurFieldsTrimWhiteSpace('nameCont')">
            </mm-text-input-control>
            <!-- Intermediary country -->
            <div id="intermediary-country-display">
              <label id="intermediary-country-label">Intermediary country</label>
              <span id="intermediary-country" data-testid="intermediary-country">{{intermediaryCountry?.value}}</span>
            </div>
          </div>
          <div id="address-country-container" class="input-box">
            <!-- Intermediary address-->
            <mm-text-input-control id="intermediary-address-first-line" [parentForm]="parentForm" [inputControlModel]="addressModel"
            (blur)="onBlurFieldsTrimWhiteSpace('address')">
            </mm-text-input-control>
            <!-- Intermediary address continued (optional) -->
            <mm-text-input-control class="input-box" [parentForm]="parentForm" [inputControlModel]="addressContModel"
            (blur)="onBlurFieldsTrimWhiteSpace('addressCont')">
            </mm-text-input-control>
          </div>
        </div>
      </div>
      <div>
        <mm-banners [hidden]="!(showIntermediaryFields$ | async)!" *ngIf="showIntermediaryWarningBanner()" id="warning-banner"
        [bannerText]="[warningIntermediaryDescription]" [type]="'warning'">
        </mm-banners>
      </div>
      <mm-wire-credit-to-interim *ngIf="(canDisplayCreditToInfo)" [parentForm]="parentForm" [countryList] ="countryListDropdown.options"
        data-testid="credit-to" [useSloa] = "(useSloa$ | async)!"></mm-wire-credit-to-interim>
      <div *ngIf="(useSloa && isISOCompliant)">
      <mm-wire-iso-four-step-intermediary *ngIf="isFourStep && (useSloa$ | async)!" [parentForm]="parentForm" [countryList] ="countryListDropdown.options"
      data-testid="four-step-sloa-intermediary" [useSloa] = "(useSloa$ | async)!"></mm-wire-iso-four-step-intermediary>
      <span id="intermediary-name-address-header" [ngClass]="(useSloa$ | async)! ? 'ft-16' : ''">{{intermediaryNameAddressSubHeader}}</span>
      <div *ngIf="(useSloa$ | async)!" class="medium-bottom-spacer">
        <div id="resp-table">
          <div id="resp-table-body">
            <div class="resp-table-row">
              <span class="table-body-cell schwab-grey" *ngIf="intermediaryAccountNumber != null">
                {{ intermediaryUseSloaAccountNumberHeader }} 
              </span>
              <span class="table-body-cell schwab-grey" *ngIf="intermediaryBIC != null">
                Business ID code (BIC)
              </span>
              <span class="table-body-cell schwab-grey" *ngIf="intermediaryClearingSysId != null">
                Clearing system ID
              </span>
              <span class="table-body-cell schwab-grey">
                Bank information
              </span>
            </div>
            <div class="resp-table-row">
              <span class="table-body-cell" *ngIf="intermediaryAccountNumber != null">
                {{intermediaryAccountNumber}}
              </span>
              <span class="table-body-cell" *ngIf="intermediaryBIC != null">
                {{intermediaryBIC}}
              </span>
              <span class="table-body-cell" *ngIf="intermediaryClearingSysId != null">
                {{intermediaryClearingSysId}}
              </span>
              <span class="table-body-cell" style="white-space: pre-line;">
                {{intermediaryUseSloaAddress}}
              </span>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div *ngIf="!(useSloa$ | async)!">
        <span id="intermediary-name-address-header" class="ft-16">{{intermediaryNameAddressSubHeader}} 
          <mm-tooltip [position]="'right'" [containsLink]="false">
            <tooltip-content>
                <div>{{recipientBankTooltip}}</div>
            </tooltip-content>
            <tooltip-trigger-element>
                <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
            </tooltip-trigger-element>
        </mm-tooltip>
        </span>
        <div class="row">
          <!-- Intermediary account number -->
          <mm-text-input-control class="input-box" [parentForm]="parentForm" [inputControlModel]="accountNumberModel"
            [errorMessage]="accountNumberError" (blur)="onBlurFieldsTrimWhiteSpace('accountNumber')">
          </mm-text-input-control>
        </div>
        <div class="row">
          <!-- Intermediary name -->
          <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('name')" [parentForm]="parentForm"
            [inputControlModel]="nameModel" [errorMessage]="nameError">
          </mm-text-input-control>
          <!-- Intermediary country -->
          <mm-select-dropdown-control id="country-control" [parentForm]="parentForm" [selectModel]="countryListDropdown">
          </mm-select-dropdown-control>
        </div>
        <div>
          <mm-banners *ngIf="isFromTemplateAndNonIsoCompliant" [titleText]="nonIsoCompliantErrorHeader" [shouldBoldTitleText]="true" [bannerText]="[nonIsoCompliantErrorDescription]" 
            [nonIsoAddressFooter]="nonIsoCompliantErrorAddressDetails" [type]="'error'" id="nonIsoCompliantWireTemplate_intermediaryErrorBanner" data-testid="nonIsoCompliantWireTemplate_intermediaryErrorBanner">
          </mm-banners>
        </div>
        <div class="row">
          <!-- Street number -->
          <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('streetNumber')" [parentForm]="parentForm" [inputControlModel]="streetNumberModel"
            [errorMessage]="streetNumberError || ''"></mm-text-input-control>
          <!-- Street name -->
          <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('streetName')" [parentForm]="parentForm" [inputControlModel]="streetNameModel"
            [errorMessage]="streetNameError || ''"></mm-text-input-control>
          <!-- Apt/Flat, suite, etc. -->
          <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('apartmentSuiteEtc')" [parentForm]="parentForm" [inputControlModel]="!isInternational ? apartmentSuiteModel : intlApartmentSuiteModel"
            [errorMessage]="apartmentSuiteEtcError || ''"></mm-text-input-control>
          <!-- Sub-locality -->
          <mm-text-input-control *ngIf="isInternational" (blur)="onBlurFieldsTrimWhiteSpace('townLocationName')" class="input-box" [parentForm]="parentForm" [inputControlModel]="townLocationNameModel"
            [errorMessage]="townLocationNameError || ''"></mm-text-input-control>
        </div>
        <div class="row">
          <!-- City -->
          <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('city')"  [parentForm]="parentForm" [inputControlModel]="!isInternational ? cityModel : intlCityModel"
          [errorMessage]="cityError || ''"></mm-text-input-control>
          <!-- District (international) -->
          <mm-text-input-control *ngIf="isInternational" class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('district')" [parentForm]="parentForm" [inputControlModel]="districtModel"
          [errorMessage]="districtError || ''"></mm-text-input-control>
          <!-- State -->
          <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('state')" [parentForm]="parentForm" [inputControlModel]="!isInternational ? stateModel : intlStateModel"
            [errorMessage]="stateError || ''"></mm-text-input-control>
          <!-- Zip -->
          <mm-text-input-control class="input-box" [parentForm]="parentForm" [inputControlModel]="!isInternational ? zipModel : intlZipModel"
          [errorMessage]="(isInternational ? intlZipError : zipError) || ''"></mm-text-input-control>
        </div>
        <div id="address-country-container" class="end-row input-box" *ngIf="hideAddressFields == 'no'">
            <!-- Department -->
            <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('department')"  [parentForm]="parentForm" [inputControlModel]="departmentModel"
              [errorMessage]="departmentError || ''"></mm-text-input-control>
            <!-- Building name -->
            <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('buildingName')" [parentForm]="parentForm" [inputControlModel]="buildingNameModel"
              [errorMessage]="buildingNameError || ''"></mm-text-input-control>
            <!-- Floor -->
            <mm-text-input-control class="input-box" (blur)="onBlurFieldsTrimWhiteSpace('floor')" [parentForm]="parentForm" [inputControlModel]="floorModel"
              [errorMessage]="floorError || ''"></mm-text-input-control>
        </div>
        <mm-show-hide-text-control data-testid="address-selection" [parentForm]="parentForm"
          [hideIntermediaryAddressFields]="hideAddressFields" [showHideTextControlModel]="intermediaryShowHideLinkModel"
          [isLinkEnabled]="!useSloa" [isIntermediary]="true" (isclosed)="isClosedAddressFields($event)">
        </mm-show-hide-text-control>
      </div>
      <hr id="bottom-divider" *ngIf="!canDisplayCreditToInfo || (useSloa$ | async)!" [ngClass] ="(useSloa$ | async)! ? '' : 'usesloa-iso-padding'">
    </div>
  </div>
</div>
